/**
 * PropsJoin.js
 * Used join any additional properties passed to a component.
 *
 * @module  PropsJoin
 * @author  Randy Lebeau
 */

module.exports = {

	joinProps: function(source, exclusion) {
		var rest = {};
		var hasOwn = Object.prototype.hasOwnProperty;
		if (source == null) {
			throw new TypeError();
		}
		for (var key in source) {
			if (hasOwn.call(source, key) && !hasOwn.call(exclusion, key)) {
				rest[key] = source[key];
			}
		}
		return rest;
	}

};



/** WEBPACK FOOTER **
 ** ./src/mixins/js/PropsJoin.js
 **/